import { useOrdenesQueRecibenMaterial } from './useSobrantes'
import estilos from './PaginaSobrantes.module.css'

/** La orden de trabajo a la que va el sobrante: solo las que no han terminado. */
export function ElegirOrden({ valor, onCambio }: { valor: string; onCambio: (id: string) => void }) {
  const ordenes = useOrdenesQueRecibenMaterial()
  return (
    <label className={estilos.campoMedio}>
      <span>Orden de trabajo</span>
      <select value={valor} onChange={(e) => onCambio(e.target.value)}>
        <option value="">{ordenes.isLoading ? 'Cargando…' : 'Elija la orden'}</option>
        {(ordenes.data ?? []).map((o) => (
          <option key={o.id} value={o.id}>
            {o.etiqueta}
          </option>
        ))}
      </select>
    </label>
  )
}
